import { useOutletContext } from "react-router-dom";
import ResvInfPage from "./resvInf";
import { IOutletContext } from "components/view/mypage/book/layout";
import CancelInfPage from "./cancelInf";

export default function BookInfPage() {
  const { resvStat } = useOutletContext<IOutletContext>();
  return (
    <>
      {resvStat !== "cancel" && <ResvInfPage />}
      {resvStat === "cancel" && <CancelInfPage />}
    </>
  );
}
